if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.error = false;
        this.keepButtonDisabled = false;

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      refreshCartDrawer(openAfter = false) {
        return fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
          .then((response) => response.json())
          .then((sections) => {
            const parser = new DOMParser();

            if (sections['cart-drawer']) {
              const html = parser.parseFromString(sections['cart-drawer'], 'text/html');

              const freshDrawer = html.querySelector('cart-drawer');
              const currentDrawer = document.querySelector('cart-drawer');

              const freshInner = html.querySelector('.drawer__inner');
              const currentInner = document.querySelector('cart-drawer .drawer__inner');

              if (freshDrawer && currentDrawer) {
                currentDrawer.className = freshDrawer.className;
              }

              if (freshInner && currentInner) {
                currentInner.replaceWith(freshInner);
              }

              const drawer = document.querySelector('cart-drawer');
              const overlay = drawer?.querySelector('#CartDrawer-Overlay');

              if (overlay && drawer) {
                overlay.addEventListener('click', drawer.close.bind(drawer));
              }
            }

            if (sections['cart-icon-bubble']) {
              const html = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');

              const freshBubble = html.querySelector('#cart-icon-bubble');
              const currentBubble = document.querySelector('#cart-icon-bubble');

              if (freshBubble && currentBubble) {
                currentBubble.innerHTML = freshBubble.innerHTML;
              }
            }

            if (openAfter) {
              setTimeout(() => {
                const drawer = document.querySelector('cart-drawer');

                if (drawer && typeof drawer.open === 'function') {
                  drawer.open();
                }
              }, 100);
            }
          })
          .catch((e) => {
            console.error('Cart drawer refresh failed:', e);
          });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.error = false;
        this.keepButtonDisabled = false;
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);

          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

              if (soldOutMessage && response.description && response.description.toLowerCase().includes('sold')) {
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.keepButtonDisabled = true;
              }

              this.error = true;

              return this.refreshCartDrawer(false);
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.keepButtonDisabled) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}